import React from 'react';
import { SvgIconProps } from '@mui/material';

import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import TurnedInNotOutlinedIcon from '@mui/icons-material/TurnedInNotOutlined';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import ExpandLessOutlinedIcon from '@mui/icons-material/ExpandLessOutlined';
import RotateLeftOutlinedIcon from '@mui/icons-material/RotateLeftOutlined';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import HandymanOutlinedIcon from '@mui/icons-material/HandymanOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import SpeedRoundedIcon from '@mui/icons-material/SpeedRounded';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import MovingIcon from '@mui/icons-material/Moving';
import FlagIcon from '@mui/icons-material/Flag';
import OutlinedFlagIcon from '@mui/icons-material/OutlinedFlag';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import GridViewIcon from '@mui/icons-material/GridView';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import AppsIcon from '@mui/icons-material/Apps';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import ReplyIcon from '@mui/icons-material/Reply';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import ShortcutOutlinedIcon from '@mui/icons-material/ShortcutOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import ShowChartOutlinedIcon from '@mui/icons-material/ShowChartOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PieChartOutlinedIcon from '@mui/icons-material/PieChartOutlined';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import TableRowsOutlinedIcon from '@mui/icons-material/TableRowsOutlined';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

import {
    CandidatesIcon,
    HomeIcon,
    JobsIcon,
    NotificationsIcon,
    ReportsIcon,
    SavedIcon,
    BackIcon,
    EditIcon,
    LinkedInIcon,
    MailIcon,
    BookmarkButtonIcon,
    ClockIcon,
    WhatsappIcon,
    ShareButtonIcon,
    ForwardIcon,
    BookmarkFilledIcon,
    ProceededCandidatesIcon,
    RejectedCandidatesIcon,
    UncheckedCandidatesIcon,
    SmallCloseIcon,
    SyncOutlineIcon,
    SearchIcon,
    FacebookIcon,
    InstagramIcon,
    TelegramIcon,
    TwitterIcon,
    CopyIcon,
    TrashIcon,
    PaperFilledIcon,
    TasksListIcon,
    JobsIconBig,
    NewCandidatesIcon,
    TableIconNew,
    NoAlertsIconBig,
    NoTasksIconBig,
    NoTrackableDataIconBig,
    ContactCalendarIcon,
    MessageIcon,
    GoogleLogoIcon,
    MicrosoftLogoIcon,
    AIStarsIcon,
    AIGenerateTextIcon,
} from './SVGIcons';
import styled from '../styled';
import AsteriskIcon from './SVGIcons/AsteriskIcon';

type CustomSvgIcon = React.FC<Omit<IconProps, 'name'>>;

type MaterialIcons = {
    AssessmentOutlinedIcon: React.FC<SvgIconProps>;
    TurnedInNotOutlinedIcon: React.FC<SvgIconProps>;
    TaskAltRoundedIcon: React.FC<SvgIconProps>;
    VisibilityOutlinedIcon: React.FC<SvgIconProps>;
    VisibilityOffOutlinedIcon: React.FC<SvgIconProps>;
    ExpandMoreOutlinedIcon: React.FC<SvgIconProps>;
    SettingsOutlinedIcon: React.FC<SvgIconProps>;
    LogoutOutlinedIcon: React.FC<SvgIconProps>;
    AddBoxOutlinedIcon: React.FC<SvgIconProps>;
    CalendarTodayOutlinedIcon: React.FC<SvgIconProps>;
    PeopleOutlineOutlinedIcon: React.FC<SvgIconProps>;
    AddCircleIcon: React.FC<SvgIconProps>;
    WorkOutlineOutlinedIcon: React.FC<SvgIconProps>;
    ManageSearchOutlinedIcon: React.FC<SvgIconProps>;
    DeleteIcon: React.FC<SvgIconProps>;
    CloseIcon: React.FC<SvgIconProps>;
    CheckIcon: React.FC<SvgIconProps>;
    UnfoldMoreIcon: React.FC<SvgIconProps>;
    ExpandLessOutlinedIcon: React.FC<SvgIconProps>;
    RotateLeftOutlinedIcon: React.FC<SvgIconProps>;
    FavoriteRoundedIcon: React.FC<SvgIconProps>;
    FavoriteBorderRoundedIcon: React.FC<SvgIconProps>;
    LocationOnOutlinedIcon: React.FC<SvgIconProps>;
    BadgeOutlinedIcon: React.FC<SvgIconProps>;
    AccessTimeOutlinedIcon: React.FC<SvgIconProps>;
    ShareOutlinedIcon: React.FC<SvgIconProps>;
    HandymanOutlinedIcon: React.FC<SvgIconProps>;
    SchoolOutlinedIcon: React.FC<SvgIconProps>;
    StarBorderRoundedIcon: React.FC<SvgIconProps>;
    ErrorOutlineRoundedIcon: React.FC<SvgIconProps>;
    SpeedRoundedIcon: React.FC<SvgIconProps>;
    AddCircleOutlineOutlinedIcon: React.FC<SvgIconProps>;
    AddRoundedIcon: React.FC<SvgIconProps>;
    ErrorOutlineIcon: React.FC<SvgIconProps>;
    CheckRoundedIcon: React.FC<SvgIconProps>;
    CloseRoundedIcon: React.FC<SvgIconProps>;
    MoreVertIcon: React.FC<SvgIconProps>;
    TrendingDownIcon: React.FC<SvgIconProps>;
    MovingIcon: React.FC<SvgIconProps>;
    FlagIcon: React.FC<SvgIconProps>;
    OutlinedFlagIcon: React.FC<SvgIconProps>;
    InfoOutlinedIcon: React.FC<SvgIconProps>;
    ErrorOutlineOutlinedIcon: React.FC<SvgIconProps>;
    GridViewIcon: React.FC<SvgIconProps>;
    DragIndicatorIcon: React.FC<SvgIconProps>;
    AppsIcon: React.FC<SvgIconProps>;
    ColorLensIcon: React.FC<SvgIconProps>;
    ContentCopyOutlinedIcon: React.FC<SvgIconProps>;
    AttachFileIcon: React.FC<SvgIconProps>;
    ArrowBackIcon: React.FC<SvgIconProps>;
    ArrowForwardIcon: React.FC<SvgIconProps>;
    FileDownloadOutlinedIcon: React.FC<SvgIconProps>;
    ReplyIcon: React.FC<SvgIconProps>;
    ReplyAllIcon: React.FC<SvgIconProps>;
    ShortcutOutlinedIcon: React.FC<SvgIconProps>;
    KeyboardArrowDownIcon: React.FC<SvgIconProps>;
    RefreshOutlinedIcon: React.FC<SvgIconProps>;
    ShowChartOutlinedIcon: React.FC<SvgIconProps>;
    BarChartOutlinedIcon: React.FC<SvgIconProps>;
    PersonOutlinedIcon: React.FC<SvgIconProps>;
    MailOutlineIcon: React.FC<SvgIconProps>;
    PieChartOutlinedIcon: React.FC<SvgIconProps>;
    EmojiEventsOutlinedIcon: React.FC<SvgIconProps>;
    TableRowsOutlinedIcon: React.FC<SvgIconProps>;
    FilterAltOutlinedIcon: React.FC<SvgIconProps>;
    SwapHorizIcon: React.FC<SvgIconProps>;
};

const materialIconsMap: MaterialIcons = {
    AssessmentOutlinedIcon: AssessmentOutlinedIcon,
    TurnedInNotOutlinedIcon: TurnedInNotOutlinedIcon,
    TaskAltRoundedIcon: TaskAltRoundedIcon,
    VisibilityOutlinedIcon: VisibilityOutlinedIcon,
    VisibilityOffOutlinedIcon: VisibilityOffOutlinedIcon,
    ExpandMoreOutlinedIcon: ExpandMoreOutlinedIcon,
    SettingsOutlinedIcon: SettingsOutlinedIcon,
    LogoutOutlinedIcon: LogoutOutlinedIcon,
    AddBoxOutlinedIcon: AddBoxOutlinedIcon,
    CalendarTodayOutlinedIcon: CalendarTodayOutlinedIcon,
    PeopleOutlineOutlinedIcon: PeopleOutlineOutlinedIcon,
    AddCircleIcon: AddCircleIcon,
    WorkOutlineOutlinedIcon: WorkOutlineOutlinedIcon,
    ManageSearchOutlinedIcon: ManageSearchOutlinedIcon,
    DeleteIcon: DeleteIcon,
    CloseIcon: CloseIcon,
    CheckIcon: CheckIcon,
    UnfoldMoreIcon: UnfoldMoreIcon,
    ExpandLessOutlinedIcon: ExpandLessOutlinedIcon,
    RotateLeftOutlinedIcon: RotateLeftOutlinedIcon,
    FavoriteRoundedIcon: FavoriteRoundedIcon,
    FavoriteBorderRoundedIcon: FavoriteBorderRoundedIcon,
    LocationOnOutlinedIcon: LocationOnOutlinedIcon,
    BadgeOutlinedIcon: BadgeOutlinedIcon,
    AccessTimeOutlinedIcon: AccessTimeOutlinedIcon,
    ShareOutlinedIcon: ShareOutlinedIcon,
    HandymanOutlinedIcon: HandymanOutlinedIcon,
    SchoolOutlinedIcon: SchoolOutlinedIcon,
    StarBorderRoundedIcon: StarBorderRoundedIcon,
    ErrorOutlineRoundedIcon: ErrorOutlineRoundedIcon,
    SpeedRoundedIcon: SpeedRoundedIcon,
    AddCircleOutlineOutlinedIcon: AddCircleOutlineOutlinedIcon,
    AddRoundedIcon: AddRoundedIcon,
    ErrorOutlineIcon: ErrorOutlineIcon,
    CheckRoundedIcon: CheckRoundedIcon,
    CloseRoundedIcon: CloseRoundedIcon,
    MoreVertIcon: MoreVertIcon,
    TrendingDownIcon: TrendingDownIcon,
    MovingIcon: MovingIcon,
    FlagIcon: FlagIcon,
    OutlinedFlagIcon: OutlinedFlagIcon,
    InfoOutlinedIcon: InfoOutlinedIcon,
    ErrorOutlineOutlinedIcon: ErrorOutlineOutlinedIcon,
    GridViewIcon: GridViewIcon,
    DragIndicatorIcon: DragIndicatorIcon,
    AppsIcon: AppsIcon,
    ColorLensIcon: ColorLensIcon,
    ContentCopyOutlinedIcon: ContentCopyOutlinedIcon,
    AttachFileIcon: AttachFileIcon,
    ArrowBackIcon: ArrowBackIcon,
    ArrowForwardIcon: ArrowForwardIcon,
    FileDownloadOutlinedIcon: FileDownloadOutlinedIcon,
    ReplyIcon: ReplyIcon,
    ReplyAllIcon: ReplyAllIcon,
    ShortcutOutlinedIcon: ShortcutOutlinedIcon,
    KeyboardArrowDownIcon: KeyboardArrowDownIcon,
    RefreshOutlinedIcon: RefreshOutlinedIcon,
    ShowChartOutlinedIcon: ShowChartOutlinedIcon,
    BarChartOutlinedIcon: BarChartOutlinedIcon,
    PersonOutlinedIcon: PersonOutlinedIcon,
    MailOutlineIcon: MailOutlineIcon,
    PieChartOutlinedIcon: PieChartOutlinedIcon,
    EmojiEventsOutlinedIcon: EmojiEventsOutlinedIcon,
    TableRowsOutlinedIcon: TableRowsOutlinedIcon,
    FilterAltOutlinedIcon: FilterAltOutlinedIcon,
    SwapHorizIcon: SwapHorizIcon,
};

const customIconMap: Record<string, CustomSvgIcon> = {
    CandidatesIcon: CandidatesIcon,
    HomeIcon: HomeIcon,
    JobsIcon: JobsIcon,
    NotificationsIcon: NotificationsIcon,
    ReportsIcon: ReportsIcon,
    SavedIcon: SavedIcon,
    BackIcon: BackIcon,
    EditIcon: EditIcon,
    LinkedInIcon: LinkedInIcon,
    ClockIcon: ClockIcon,
    MailIcon: MailIcon,
    BookmarkButtonIcon: BookmarkButtonIcon,
    ShareButtonIcon: ShareButtonIcon,
    WhatsappIcon: WhatsappIcon,
    ForwardIcon: ForwardIcon,
    BookmarkFilledIcon: BookmarkFilledIcon,
    ProceededCandidatesIcon: ProceededCandidatesIcon,
    RejectedCandidatesIcon: RejectedCandidatesIcon,
    UncheckedCandidatesIcon: UncheckedCandidatesIcon,
    SmallCloseIcon: SmallCloseIcon,
    SyncOutlineIcon: SyncOutlineIcon,
    SearchIcon: SearchIcon,
    FacebookIcon: FacebookIcon,
    InstagramIcon: InstagramIcon,
    TelegramIcon: TelegramIcon,
    TwitterIcon: TwitterIcon,
    CopyIcon: CopyIcon,
    TrashIcon: TrashIcon,
    PaperFilledIcon: PaperFilledIcon,
    TasksListIcon: TasksListIcon,
    JobsIconBig: JobsIconBig,
    NoAlertsIconBig: NoAlertsIconBig,
    NoTasksIconBig: NoTasksIconBig,
    NoTrackableDataIconBig: NoTrackableDataIconBig,
    NewCandidatesIcon: NewCandidatesIcon,
    TableIconNew: TableIconNew,
    ContactCalendarIcon: ContactCalendarIcon,
    MessageIcon: MessageIcon,
    GoogleLogoIcon: GoogleLogoIcon,
    MicrosoftLogoIcon: MicrosoftLogoIcon,
    AIStarsIcon: AIStarsIcon,
    AIGenerateTextIcon: AIGenerateTextIcon,
    AsteriskIcon: AsteriskIcon,
};

const IconWrapper = styled('div')<{ size: number }>(({ size }) => ({
    width: `${size}px`,
    height: `${size}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
        maxWidth: '100%',
        maxHeight: '100%',
    },
}));

export type IconName =
    | keyof typeof materialIconsMap
    | keyof typeof customIconMap;

export interface IconProps extends Omit<SvgIconProps, 'component'> {
    name: string;
    size?: number;
    noWrapper?: boolean;
}

export const Icon: React.FC<IconProps> = ({
    name,
    size = 24,
    color,
    noWrapper,
    ...props
}) => {
    const style: React.CSSProperties = {
        color: color,
        ...props.style,
    };

    if (!noWrapper) {
        style.width = `${size}px`;
        style.height = `${size}px`;
    }

    if (name in materialIconsMap) {
        const MaterialIconComp =
            materialIconsMap[name as keyof typeof materialIconsMap];
        return <MaterialIconComp style={style} {...props} />;
    }

    if (name in customIconMap) {
        const CustomIconComp =
            customIconMap[name as keyof typeof customIconMap];
        if (noWrapper) {
            return <CustomIconComp color={color} {...props} />;
        }
        return (
            <IconWrapper size={size}>
                <CustomIconComp color={color} {...props} />
            </IconWrapper>
        );
    }

    console.warn(`Icon "${name}" not found`);
    return null;
};

export default Icon;
